import Vue from 'vue';
import ElementUI from 'element-ui';
import VueMoment from 'vue-moment';
import locale from 'element-ui/lib/locale/lang/fr';
import 'element-ui/lib/theme-chalk/index.css';
import 'quill/dist/quill.snow.css';
import App from './App.vue';
import router from './router';


Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(VueMoment);

Vue.directive('selection', {
  inserted: (el, binding) => {
    const f = (evt) => {
      if (binding.value(evt, el)) {
        document.removeEventListener('selectionchange', f);
      }
    };
    document.addEventListener('selectionchange', f);
  },
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
